// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","396":"cd9d42e8","455":"ab5ce867","977":"c3425159"}[chunkId] + ".chunk.js";
};